module.exports = __webpack_public_path__ + "img/tea_right.d5941ab1.png";